export class ErrorItem {
    constructor(public Id:string,public Message:string)
    {

    }

}